// applyCardSize();

// // Observe DOM changes (cards being added/updated)
// const observer = new MutationObserver((mutations) => {
//   let shouldRun = false;

//   mutations.forEach(mutation => {
//     if (
//       mutation.type === "childList" &&
//       (mutation.addedNodes.length > 0)
//     ) {
//       shouldRun = true;
//     }
//   });

//   if (shouldRun) {
//     applyCardSize();
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });
document.addEventListener("DOMContentLoaded", (event) => {

   applyCardSize()
const resizeObserver = new ResizeObserver(function() {
  applyCardSize();
});
resizeObserver.observe(document.body);
function applyCardSize() {

if (!window.location.pathname.includes("collections")) {

  const sliders = document.querySelectorAll(".wt-slider__container--featured");

  sliders.forEach(slider => {
    const cards = slider.querySelectorAll(".product-card-jtpl");

    // Reset heights first
    cards.forEach(el => el.style.height = "auto");

    let maxHeight = 0;

    // Find max height within THIS slider
    cards.forEach(el => {
      if (el.offsetHeight > maxHeight) {
        maxHeight = el.offsetHeight;
      }
    });

    // Apply max height to cards in THIS slider only
    cards.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  });

}
else{
 const cards = document.querySelectorAll(".product-card-jtpl");

    cards.forEach(el => el.removeAttribute("style"));

    let maxHeight = 0;

    cards.forEach(el => {
      if (el.offsetHeight > maxHeight) {
        maxHeight = el.offsetHeight;
      }
    });

    cards.forEach(el => {
      el.style.height = maxHeight + "px";
    }); 
}
}

// Apply max height to all
    /************ CODE FOR CUSTOM VARIANT POPUP STARTS ************/

    /*** CODE TO PULL AND INJECT THE POPUP DATA STARTS ***/
 $(document).on("click", "quick-add.enable_cstm_popup", function (e) {
    e.preventDefault();
    e.stopPropagation(); 
    let handle=$(this).attr("data-product-handle")
    $('#variant-popup-container').addClass("active")
    // $('#variant-popup-container .variant-popup-wrapper').fadeIn()
    $('#variant-popup-container').html(($(this).parents(".card__container").find(".variant-popup-jtpl").html()));
console.log("hhh",$(this).parents(".card__container").find(".variant-popup-jtpl").html());

    setTimeout(() => {
      if (window.innerWidth>525) {
      $('#variant-popup-container.active .variant-popup-wrapper')
      .animate({
        top: '50%'
      });
    }
    else{
      $('#variant-popup-container.active .variant-popup-wrapper')
    .css('transform', 'translateY(0)');
    }
    }, 50);
// $.ajax({
//   url: `/products/${handle}?view=variant-popup`,
//   method: "GET",
//   dataType: "html",
//   cache:true,
//   success: function(response) {
//     // Convert response string into DOM
//     var html = $('<div>').html(response);

//     // Extract the required section
//     var content = html.find('.variant-popup-wrapper');

//     // Inject into your page
//     $('#variant-popup-container').html(content);
//     if (window.innerWidth>525) {
//       $('#variant-popup-container.active .variant-popup-wrapper')
//       .animate({
//         top: '50%'
//       });
//     }
//     else{
//       $('#variant-popup-container.active .variant-popup-wrapper')
//     .css('transform', 'translateY(0)');
//     }
//       //  $('#variant-popup-container').addClass("active")
//   },
//   error: function(xhr, status, error) {
//     console.error("Error loading variant popup:", error);
//   }
// });
    console.log("quick-add.enable_cstm_popup====");
});
/*** CODE TO PULL AND INJECT THE POPUP DATA ENDS ***/

$(document).on("click",".variant-popup-wrapper .close-btn",function () {
  $("#variant-popup-container .variant-popup-wrapper").remove();
    $('#variant-popup-container').removeClass("active");
    // $('#variant-popup-container .variant-popup-wrapper').fadeOut()
  })
  // Close when clicking outside the popup
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".variant-popup-wrapper").length) {
      $("#variant-popup-container .variant-popup-wrapper").remove();
      $('#variant-popup-container').removeClass("active");
      // $('#variant-popup-container .variant-popup-wrapper').fadeOut()
    }
});
$(document).on("click", ".variant-popup-wrapper button.add-variant", function () {
    console.log($(this).closest(".qty-box"));
    $(this).parents(".variant-item").find("input[name='quantity']").val(1)
    $(this).parent().find(".qty-box").removeClass("hidden");
    $(this).hide()
    $(".variant-popup-wrapper .qty-error").remove()
    updateTotalPrice()
});

$(document).on("click", ".variant-popup-wrapper .js-counter-increase", function () {
    let $input = $(this).siblings(".js-counter-quantity");

    let currentVal = parseInt($input.val()) || 1;
    let max = parseInt($input.attr("max")) || 999;

    if (currentVal < max) {
        $input.val(currentVal + 1);
    }
    updateTotalPrice()
});

$(document).on("click", ".variant-popup-wrapper .js-counter-decrease", function () {
    let $input = $(this).siblings(".js-counter-quantity");

    let currentVal = parseInt($input.val()) || 0;
    let min = parseInt($input.attr("min")) || 0;

    if (currentVal > min) {
        $input.val(currentVal - 1);
    }
    if ($input.val()<1) {
        $(this).parents(".variant-item").find("button.add-variant").show()
        $(this).parents(".qty-box").addClass("hidden")
    }
    updateTotalPrice()
});
$(document).on("click", ".variant-popup-wrapper .cstm-atc-btn", function (e) {
  e.preventDefault();

  const items = [];

  $(".variant-popup-wrapper .variant-list .variant-item.available:not(:has(.qty-box.hidden))").each((i, el) => {

    const variantId = $(el).data("v-id");
    const quantity = parseInt(
      $(el).find("input[name='quantity']").val()
    );

    // Skip empty or 0 qty
    if (variantId && quantity > 0) {
      items.push({
        id: variantId,
        quantity: quantity
      });
    }
  });

  // Stop if no items
  if (!items.length) {
    // alert("Please select quantity");
    $(".popup-footer.cstm-atc-btn");
    let $footer = $(".popup-footer.cstm-atc-btn");
// remove old error if exists
$footer.next(".qty-error").remove();
// add new error
$footer.after('<div class="qty-error" style="color:red;text-align:center;">Please select quantity</div>');
    return;
  }
$(".variant-popup-wrapper .popup-footer .confirm-txt").text("Adding...")
  // AJAX Add to Cart
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify({ items: items }),
    contentType: "application/json",
    dataType: "json",

    success: function (response) {
      console.log("Added to cart:", response);
       $(".variant-popup-wrapper .close-btn").trigger("click")
        document.dispatchEvent(
    new CustomEvent("cart-drawer:refresh")
  );
  // Open drawer
  const cartDrawer = document.querySelector("cart-drawer");
  
  if (cartDrawer && !cartDrawer.isOpen) {
    cartDrawer.toggleDrawerClasses();
  }
  $(".variant-popup-wrapper .popup-footer .confirm-txt").text("Confirm")

    },

    error: function (xhr) {
      console.error(xhr);
      let $footer = $(".popup-footer.cstm-atc-btn");
      // remove old error if exists
      $footer.next(".qty-error").remove();
      // add new error
      $footer.after('<div class="qty-error" style="color:red;text-align:center;">'+xhr.responseJSON.message+'</div>');
      $(".variant-popup-wrapper .popup-footer .confirm-txt").text("Confirm")
      document.dispatchEvent(
        new CustomEvent("cart-drawer:refresh")
      );
    }
  });
});
function updateTotalPrice() {
 let totalPrice = 0;

$(".variant-popup-wrapper .variant-list .variant-item.available:not(:has(.qty-box.hidden))").each((i, el) => {
  let quantity = parseInt($(el).find("input[name='quantity']").val()) || 0;
  let price = parseFloat($(el).attr("data-price")) / 100 || 0; // convert paise → ₹

  totalPrice += quantity * price;
});

console.log("Total Price-- ₹", totalPrice.toFixed(2));
$(".variant-popup-wrapper .popup-footer .total-price").text("₹ "+totalPrice)
}
    /************ CODE FOR CUSTOM VARIANT POPUP ENDS ************/

});
